import React from 'react'

const projects = [
  { img: 'cripto.PNG', title: 'Cryptocurrency quoter' },
  { img: 'planif.PNG', title: 'Expense control' },
  { img: 'clima.png', title: 'Weather app' },
  { img: 'dating-form.PNG', title: 'Dating form' },
  { img: '06.png', title: 'condominium web' },
  { img: 'condominiumApp.png', title: 'condominium App' },
  { img: '05.png', title: 'Solicitudes y aprobaciones de pago' },
]

const ProjectsComponent = () => {
  return (
    <div className="container section" id='projects'>
        <div className="section__header">
            <span className="section__eyebrow">&lt;Projects /&gt;</span>
            <h2 className="section__title">My Projects</h2>
        </div>
        <div className="projects__content grid">
            {projects.map((project) => (
                <article className="projects__card" key={project.img}>
                    <div className="projects__bar">
                        <span className="projects__dot projects__dot--red"></span>
                        <span className="projects__dot projects__dot--yellow"></span>
                        <span className="projects__dot projects__dot--green"></span>
                    </div>
                    <div className="projects__body">
                        <img
                            src={`${process.env.PUBLIC_URL}/imgProjects/${project.img}`}
                            className="projects__img"
                            alt={project.title}
                        />
                        <div className="projects__modal">
                            <div>
                                <h3 className="projects__title">{project.title}</h3>
                            </div>
                        </div>
                    </div>
                </article>
            ))}
        </div>
    </div>
  )
}

export default ProjectsComponent
